// datefns format https://date-fns.org/v2.19.0/docs/format

export default {
  FORMAT_DATE: 'dd-MM-yyyy',
  FORMAT_TIME: 'HH:mm:ss',
  FORMAT_DATETIME: 'dd-MM-yyyy, HH:mm:ss',
}
